/** Width of the knob on the score and metric bars - the calibration tracker sizes its own. */
export const KNOB_WIDTH = 68;

export const trackRatio = (value: number, max: number) => (max > 0 ? Math.min(Math.max(value / max, 0), 1) : 0);

/** Knob centres run one knob half-width in from each end, so the knob never overflows the track. */
export const knobOffset = (ratio: number, knobWidth: number) =>
    `calc(${knobWidth / 2}px + (100% - ${knobWidth}px) * ${ratio})`;

/** Same centre in pixels, for laying out a label that has to stay under the knob. */
export const knobCenter = (ratio: number, trackWidth: number, knobWidth: number) =>
    knobWidth / 2 + (trackWidth - knobWidth) * ratio;

/** Shared so the knob, the segments it splits and the label under it travel together. */
export const TRACK_TRANSITION = 'transition-[left,width] duration-700 motion-reduce:transition-none';
